/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * Allowed login factor
 * @export
 */
export const FactorMethod = {
    Webauthn: 'webauthn',
    EmailLink: 'email_link',
    SmsLink: 'sms_link',
    OtpViaSms: 'otp_via_sms',
    OtpViaEmail: 'otp_via_email',
    Totp: 'totp',
    Oidc: 'oidc',
    Saml: 'saml',
    Api: 'api',
    DirectId: 'direct_id',
    Password: 'password',
    Impersonate: 'impersonate',
    Anonymous: 'anonymous'
} as const;
export type FactorMethod = typeof FactorMethod[keyof typeof FactorMethod];


export function FactorMethodFromJSON(json: any): FactorMethod {
    return FactorMethodFromJSONTyped(json, false);
}

export function FactorMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): FactorMethod {
    return json as FactorMethod;
}

export function FactorMethodToJSON(value?: FactorMethod | null): any {
    return value as any;
}

